import { create } from 'zustand';
import { getRates } from 'shared/api';

interface RatesState {
  rates: { stars: number; ton: number };
  fetchRates: () => Promise<void>;
}

export const useRatesStore = create<RatesState>((set) => ({
  rates: { stars: 0, ton: 0 },
  fetchRates: async () => {
    const { data } = await getRates();
    set({ rates: data });
  },
}));
